/**
 * Auth Debug Utility
 * Helper to debug authentication issues
 */

export const debugAuth = () => {
    console.group('🔍 Auth Debug Info');

    // Check localStorage
    const token = localStorage.getItem('adminToken');
    const user = localStorage.getItem('adminUser');

    console.log('Token exists:', !!token);
    console.log('Token value:', token ? token.substring(0, 20) + '...' : 'null');
    console.log('User exists:', !!user);

    if (user) {
        try {
            const parsedUser = JSON.parse(user);
            console.log('User data:', parsedUser);
        } catch (e) {
            console.error('Failed to parse user:', e);
        }
    }

    // Check if token is valid JWT format
    if (token) {
        const parts = token.split('.');
        console.log('Token parts:', parts.length === 3 ? 'Valid JWT format' : 'Invalid JWT format');

        if (parts.length === 3) {
            try {
                const payload = JSON.parse(atob(parts[1]));
                console.log('Token payload:', payload);
                console.log('Token expired:', payload.exp ? new Date(payload.exp * 1000) < new Date() : 'No expiry');
            } catch (e) {
                console.error('Failed to decode token:', e);
            }
        }
    }

    console.groupEnd();
};

export const clearAuth = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    console.log('✅ Auth data cleared');
};

export const testAuthHeader = () => {
    const token = localStorage.getItem('adminToken');
    const header = token ? `Bearer ${token}` : '';
    console.log('Authorization header:', header.substring(0, 30) + '...');
    return header;
};
